import { axios } from 'api/axios'
import { reg, wyinsUrl } from 'api/config'

let wechat = (shareCfg, link) => {
  let params = {
    url: link,
    appId: 'wxe2a04a49c02b1d5d'//reg ?  : 'wx7eb095d6d27a8cee'
  }
  // if (appid) {
  //   params.appId = appid
  // }
  return axios
    .get(`${wyinsUrl}/wx/page/createJsApiSignature`, { params })
    .then(res => {
      let response = res.data,
        suc = response.success,
        info = response.info,
        NOOP = function () { },
        data
      if (suc) {
        wx.config({
          debug: false,
          appId: response.data.appId, // 必填，公众号的唯一标识
          timestamp: response.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
          signature: response.data.signature, // 必填，签名，见附录1
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
          openTagList: ['wx-open-launch-app']
        })
        wx.ready(function () {
          wx.onMenuShareTimeline({
            // debug: true,
            title: shareCfg.title, // 分享标题
            link: shareCfg.link, // 分享链接
            imgUrl: shareCfg.imgUrl, // 分享图标
            success: shareCfg.success || NOOP
          })
          wx.onMenuShareAppMessage({
            // debug: true,
            title: shareCfg.title, // 分享标题
            desc: shareCfg.desc, // 分享描述
            link: shareCfg.link, // 分享链接
            imgUrl: shareCfg.imgUrl, // 分享图标
            success: shareCfg.success || NOOP
          })
        })
        wx.error(function (res) { })
      } else {
        console.log(info)
      }
    })
}

export default wechat
